export const local = {
  get: (key: string) => {
    const v = localStorage.getItem(key);
    return v ? JSON.parse(v) : null;
  },
  set: (key: string, value: any) =>
    localStorage.setItem(key, JSON.stringify(value)),
  remove: (key: string) => localStorage.removeItem(key),
};
